"use client"

import React from "react"
import styled from "styled-components"
import { P } from "@motorata/base-ui.components.atoms.typography";
import { blockStyles } from "../common/_atoms"

const Block = ({ title, text }: { title: string; text: string }) => {
  return (
    <BlockWrapper>
      <Number>
        {title}
      </Number>
      <P small textAlign="center">
        {text}
      </P>
    </BlockWrapper>
  )
}

const NumbersSection = () => {
  return (
    <Wrapper>
      <Block
        title="115 mln"
        text="wartość finansowania w 2022"
      />
      <Block
        title="88%"
        text="umowy leasingowe"
      />
      <Block
        title="58%"
        text="pojazdy fabrycznie nowe"
      />
    </Wrapper>
  )
}

export default NumbersSection

const Number = styled.span`
  font-size: 80px;
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.color.primary};

  @media (max-width: 900px) {
    font-size: 60px;
  }
`

const BlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(33% - 4rem);
  margin: 0 2rem;

  @media (max-width: 1100px) {
    width: calc(50% - 4rem);
  }

  @media (max-width: 900px) {
    width: calc(100% - 4rem);
  }
`

const Wrapper = styled.div`
  ${blockStyles};
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
`
